<script>
  import { countries } from 'src/global/getCountries';
  import Select from 'svelte-select';

  export let country = null;
  export let refreshCallback = () => {};

  const countriesSelect = [];
  for (const [k, v] of Object.entries(countries)) {
    countriesSelect.push({ value: k, label: v })
  }
</script>

<span class="date-label">Country</span>
<div class="select-country"> 
  <Select bind:value={country} items={countriesSelect} placeholder="Select country" on:change={refreshCallback} on:clear={() => {country = null; refreshCallback()}}></Select>
</div>

<style>

  .select-country {
    width: 250px;
    display: inline-block;
    vertical-align: top;
  }

  .select-country :global(.selectContainer) {
    width: 100%;
    height: 39px !important;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }

  .select-country :global(.clearSelect) {
    top: 0 !important;
    bottom: 0 !important;
  }
</style>